import withOptions from 'utils/functions/withOptions.util';

const MIN_LENGTH = 8;

const RE_CASE_LOWER = /[a-z+]/;
const RE_CASE_UPPER = /[A-Z]+/;
const RE_NUMBER = /[0-9]+/;

const validatePassword = withOptions(({ value }) => {
  if (value === '') return false;

  // this means the value is not a string, more or less, so return null instead of false
  if (!value || !value.length) return null;

  if (!RE_CASE_LOWER.test(value)) return false;
  if (!RE_CASE_UPPER.test(value)) return false;
  if (!RE_NUMBER.test(value)) return false;

  return value.length >= MIN_LENGTH;
});

// noinspection JSUnusedGlobalSymbols
export default validatePassword;
